const formatDate = (date) => {
  const temp = new Date(date);
  const splitDate = temp.toString().split(' ');
  return [splitDate[2], splitDate[1].concat(','), splitDate[3]].join(' ');
};

export default formatDate;
